export * as default from "./appGtag.service";
